module.exports = {"211403001":"葫芦岛街道","211403002":"东街道","211403003":"西街道","211403004":"望海寺街道","211403005":"龙湾街道","211403006":"滨海街道","211403007":"双龙街道","211403008":"玉皇街道","211403009":"连湾街道","211403010":"北港街道","211403201":"双树乡","211403400":"葫芦岛经济开发区","211403401":"葫芦岛市专利技术园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211403.json
// module id = 550
// module chunks = 0